<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>افزودن گیرنده‌ها</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                </CCol>
                                 <CCol sm="3">
                                    <CInputFile label="آپلود فایل"
                                        @change="form.file.val=$event[0]"
                                        :description="form.file.inv"
                                    />
                                </CCol>                              
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> افزودن</CButton>
                        </div>    
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data() {
        return {
            form: {
                user_id: {val: this.$store.state.user_id, inv: '', v: { req: true, max: 8 }},
                file: {val: '', inv: '', v: { req: true }},
			},
            users: [],
            disable: false,
        }
    },
    mounted(){
        this.get_users();
    },
    methods: {
        submit(){
            if(this.disable == false){
                const data = new FormData();
                for (const key in this.form){
                    data.set(key, this.form[key].val);
                }
                data.set('gradual_sms_group_id', this.$route.params.id);
                this.axios.post('out_box_gradual_sms_rcv_numbers/', data, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                    .then(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'افزودن با موفقیت انجام شد.'
                        });
                        for (const key in this.form){
                            this.form[key].val = '';
                        }
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    })
            }
        },
        get_users(){
            this.axios.get('users/?type=add_out_box_gradual_sms_rcv_numbers')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.name}` });
                    });
                })
        },
    },
	beforeCreate(){
        if(this.$store.state.perms.can_add_out_box_gradual_sms_rcv_numbers == false
            && this.$store.state.can_add_out_box_gradual_sms_rcv_numbers_for_same_group_users == false
            && this.$store.state.can_add_out_box_gradual_sms_rcv_numbers_for_all_users == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>
